import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-okcancel-dialog',
  templateUrl: './okcancel-dialog.component.html',
  styleUrls: ['./okcancel-dialog.component.css']
})
export class OkcancelDialogComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data
  ){

  }
}
